<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <navbar>
            <!--<template v-slot:navbarname>
                <b-button class="btn-round"
                          :variant="(isOpenFormAddNew ? 'danger' : 'primary')"
                          @click="showAndHideForm">
                    {{ (isOpenFormAddNew ? "close" : "+ Add Comment")}}
                </b-button>
            </template>-->
        </navbar>
        <!--END Navbar-->


        <b-card title="Add">
            <template>
                <b-form-group
                        label="username">
                    <b-input v-model="form.username" placeholder=""></b-input>
                </b-form-group>
                <b-form-group
                        class="required"
                        label="title">
                    <b-input v-model="form.title" placeholder=""></b-input>
                </b-form-group>
                <b-form-group label="rating">
                    <b-form-spinbutton v-model="form.rating" min="1" max="5"></b-form-spinbutton>
                </b-form-group>
                <b-form-group
                        class="required"
                        label="select product">
                    <v-select
                            class="mb-4"
                            placeholder="select"
                            :reduce="product_title => product_title.product_id"
                            label="product_title"
                            v-model="form.product_id"
                            :options="products"></v-select>
                </b-form-group>
                <b-form-group
                        class="required"
                        label="description">
                    <tinymce id="d1" v-model="form.description"></tinymce>
                </b-form-group>
                <br>
                <br>
                <template v-if="commentId > 0">
                    <b-button @click="updateComment" variant="success">{{$t('saveTitle')}}</b-button>
                </template>
                <template v-else>
                    <b-button @click="storeComment" variant="success">{{$t('saveTitle')}}</b-button>
                </template>
            </template>

        </b-card>
        <!--END Form-->

        <b-card>
            <b-row>
                <b-col cols="12" md="6">
                    <b-form-group label="filter">
                        <v-select
                                placeholder="select product"
                                :reduce="product_title => product_title.product_id"
                                label="product_title"
                                v-model="filter.products"
                                @input="onSelectFilter"
                                multiple
                                :options="products"></v-select>
                    </b-form-group>

                </b-col>
                <b-col cols="12" md="6" v-if="filter.commentIds.length > 0">
                    <b-form-group :label="$t('selectAction')">
                        <b-form-select
                                @input="onSelectProcessGroup"
                                v-model="filter.type">
                            <b-form-select-option value="pending">pending</b-form-select-option>
                            <b-form-select-option value="publish">publish</b-form-select-option>
                            <b-form-select-option value="delete">delete</b-form-select-option>
                        </b-form-select>
                    </b-form-group>

                </b-col>
            </b-row>
        </b-card>


        <b-card v-if="comments.length > 0">

            <div class="table-responsive">
                <b-table :fields="table.fields" :items="filterItem">

                    <template v-slot:cell(select)="row">
                        <b-form-checkbox
                                :id="'ch'+row.item.id"
                                :name="'ch'+row.item.id"
                                v-model="filter.commentIds"
                                :value="row.item.id"
                        >

                        </b-form-checkbox>
                    </template>

                    <template v-slot:cell(action)="row">
                        <b-button block variant="info" @click="editItem(row.item)">Edit</b-button>
                        <b-button block variant="danger" @click="deleteComment(row.item.id)">Delete</b-button>
                    </template>

                </b-table>


            </div>

            <infinite-loading :identifier="infiniteId" :distance="1" @infinite="getComments"></infinite-loading>

        </b-card>


    </div>
</template>

<script>
    import Navbar from "../Partials/Navbar";
    import Http from '../../Services/HttpService/HttpService'
    import Notification from '../../Services/Notification/Nottification'
    import 'vue-select/dist/vue-select.css';

    export default {
        name: "Index",
        components: {Navbar},
        data() {
            return {
                page: 1,
                infiniteId: +new Date(),
                commentId: 0,
                isEdit: false,
                isOpenFormAddNew: false,
                comments: [],
                products: [],
                filter: {
                    products: [],
                    commentIds: [],
                    type: null,
                },
                form: {
                    username: null,
                    title: null,
                    description: null,
                    rating: 1,
                    product_id: null
                },
                table: {
                    fields: [
                        {
                            key: 'select',
                            label: 'select'
                        },
                        {
                            key: 'user',
                            label: 'Nutzername'
                        },
                        {
                            key: 'product_title',
                            label: 'Produkte'
                        },
                        {
                            key: 'title',
                            label: 'Titel'
                        },
                        {
                            key: 'description',
                            label: 'Text'
                        },
                        {
                            key: 'rating',
                            label: 'Rate'
                        },
                        {
                            key: 'status',
                            label: 'Status'
                        },
                        {
                            key: 'date',
                            label: 'Datum'
                        },
                        {
                            key: 'action',
                            label: 'action'
                        },
                    ]
                },
            }
        },
        computed: {
            filterItem() {
                return this.comments.map((item) => {
                    let tmp = item;
                    item.status === 'pending' ? tmp._rowVariant = 'warning' : tmp._rowVariant = '';
                    return tmp;

                })
            }
        },
        methods: {
            onSelectProcessGroup() {
                this.updateProcessGroup();
            },
            onSelectFilter() {
                this.page = 1;
                this.comments = [];
                this.infiniteId += 1;
                this.getComments();
            },
            showAndHideForm() {
                this.isOpenFormAddNew = !this.isOpenFormAddNew;

                if (!this.isOpenFormAddNew) {
                    this.resetForm();
                }
            },
            resetForm() {
                this.form.username = null;
                this.form.title = null;
                this.form.description = '';
                this.form.rating = 1;
                this.form.product_id = null;
                this.commentId = 0;
                this.isOpenFormAddNew = false;
            },
            editItem(item) {
                window.scrollTo(0, 0);
                this.isOpenFormAddNew = true;
                this.commentId = item.id;
                this.form.title = item.title;
                this.form.description = item.description;
                this.form.rating = item.rating;
                this.form.product_id = item.product_id;
                this.form.username = item.user;
            },
            updateComment() {
                if (this.form.title === null) {
                    Notification.error("please enter title");
                    return;
                }
                if (this.form.description === null) {
                    Notification.error("please enter description");
                    return;
                }
                if (this.form.product_id === null) {
                    Notification.error("please select product");
                    return;
                }

                this.$Progress.start();
                Http.post(Http.apiurlV2() + 'comment/update/' + this.commentId, this.form)
                    .then(response => {
                        if (response.data.status_code === Http.ok()) {
                            this.$Progress.finish();
                            this.isEdit = false;
                            this.resetForm();
                            this.onSelectFilter();
                            Notification.success(response.data.message)
                        } else {
                            this.$Progress.finish();
                            Notification.error(response.data.message)
                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })

            },
            updateProcessGroup() {
                if (confirm(this.$t('alertText'))) {
                    this.$Progress.start();
                    Http.post(Http.apiurlV2() + 'comment/process/group', {
                        commentIds: this.filter.commentIds,
                        type: this.filter.type,
                    })
                        .then(response => {
                            if (response.data.status_code === Http.ok()) {
                                this.$Progress.finish();
                                this.onSelectFilter();
                                this.filter.commentIds = [];
                                this.filter.type = null;
                                Notification.success(response.data.message)
                            } else {
                                this.$Progress.finish();
                                Notification.error(response.data.message)
                            }
                        })
                        .catch(error => {
                            this.$Progress.finish();
                        })
                }

            },
            storeComment() {

                if (this.form.title === null) {
                    Notification.error("please enter title");
                    return;
                }
                if (this.form.description === null) {
                    Notification.error("please enter description");
                    return;
                }
                if (this.form.product_id === null) {
                    Notification.error("please select product");
                    return;
                }

                this.$Progress.start();
                Http.post(Http.apiurlV2() + 'comment/store', this.form)
                    .then(response => {
                        if (response.data.status_code === Http.created()) {
                            this.$Progress.finish();
                            this.resetForm();
                            this.getComments();
                            Notification.success(response.data.message)
                        } else {
                            this.$Progress.finish();
                            Notification.error(response.data.message)
                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })

            },
            getComments($state) {
                this.$Progress.start();
                Http.post(Http.apiurlV2() + 'comment/index?page=' + this.page, {
                    products: this.filter.products
                })
                    .then(response => {
                        if (response.data.status_code === Http.ok()) {
                            this.$Progress.finish();
                            if (response.data.data.length > 0) {
                                this.page += 1;
                                this.comments.push(...response.data.data);
                                $state.loaded();
                            }else {
                                $state.complete();
                            }

                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },
            getProducts() {
                this.$Progress.start();
                Http.get(Http.apiurlV2() + 'comment/products')
                    .then(response => {
                        if (response.data.status_code === Http.ok()) {
                            this.$Progress.finish();
                            this.products = response.data.data;
                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },
            deleteComment(id) {
                if (confirm(this.$t('alertText'))) {
                    this.$Progress.start();
                    Http.get(Http.apiurlV2() + 'comment/delete/' + id)
                        .then(response => {
                            this.$Progress.finish();
                            if (response.data.status_code === Http.ok()) {
                                this.onSelectFilter();
                                Notification.success(response.data.message)
                            } else {
                                Notification.error(response.data.message)
                            }
                        })
                        .catch(error => {
                            this.$Progress.finish();
                        })
                }

            },
        },
        created() {
            this.getProducts();
            this.getComments();
        }
    }
</script>

<style scoped>

</style>